import { composeIO } from 'react-compose-io'
import { opsEmAbertoPorParceiroIO } from './OpsEmAbertoPorParceiro.IO'
import { OpsEmAbertoPorParceiroView } from './OpsEmAbertoPorParceiro.View'

export const OpsEmAbertoPorParceiro = composeIO(OpsEmAbertoPorParceiroView, opsEmAbertoPorParceiroIO)
